module.exports = __webpack_public_path__ + "img/Taco-Papas.bd022a00.jpg";